import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import FilterLink from '../../../components/filter/FilterLink'
import QuestionPickerModal from './QuestionPickerModal'

const QuestionPicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation(['questions', 'common'])
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiListCheck2'}
        label={label || t('questions:question')}
        value={compactString(value, { t: t, tField: 'questionIds' })}
        onClick={() => setOpen(true)}
      />
      <QuestionPickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default QuestionPicker
